import React, { useState, useRef, useEffect } from 'react'
import './feedback.css'
import MUIDataTable from 'mui-datatables'
import { Grid } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/system';
import Loader from '../../components/Loader'
import { format } from 'date-fns'
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'
import { TableCell } from '@mui/material'
import { TableRow } from '@mui/material'
import Rating from '@mui/material/Rating';
import { feedbackList, feedbackListAll } from '../../actions/feedback'
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import moment from 'moment'
import TextField from '@mui/material/TextField';
import Select from 'react-select';

const { afterToday, allowedMaxDays, combine } = DateRangePicker;

const Feedback = ({ history }) => {

    const [responsive, setResponsive] = useState('simple')
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const feedback = useSelector((state) => state.feedback)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState('')
    const loaders = useSelector((state) => state.loader)
    const [allData, setAllData] = useState([]);
    const [date, setDates] = useState(null);
    const [rating, setRating] = useState(null);
    const [status, setStatus] = useState(null);
    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState('auto');

    useEffect(() => {
        const updateTableHeight = () => {
        if (tableRef.current) {
            const rect = tableRef.current.getBoundingClientRect();
            console.log("rect", rect);
            const remainingHeight = window.innerHeight - rect.top;
            const newHeight = remainingHeight - 60; // Subtract 100px as per requirement
            setTableHeight(newHeight);
            console.log(newHeight);
        }
        };

        updateTableHeight();
        window.addEventListener('resize', updateTableHeight);

        return () => {
        window.removeEventListener('resize', updateTableHeight);
        };
    }, []);


    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")

        }

    }, [])

    const optionSelect = [
        { value: '0', label: 'All' },

        { value: 'critical', label: 'Critical (0.1 - 1)', svg: <svg height="12" width="10.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#FFD43B" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" /></svg>, icon: <svg xmlns="http://www.w3.org/2000/svg" height="12" width="10.5" viewBox="0 0 448 512"><path fill="#f01414" d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z" /></svg> },
        { value: 'average', label: 'Average  (1.1 - 3.5)', svg: <svg height="12" width="10.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#FFD43B" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" /></svg>, icon: <svg xmlns="http://www.w3.org/2000/svg" height="12" width="10.5" viewBox="0 0 448 512"><path fill="#FFD43B" d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z" /></svg> },
        { value: 'good', label: 'Good  (3.6 - 5)', svg: <svg height="12" width="10.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#FFD43B" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" /></svg>, icon: <svg xmlns="http://www.w3.org/2000/svg" height="12" width="10.5" viewBox="0 0 448 512"><path fill="#0fbb0c" d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z" /></svg> },
    ];

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            display: 'flex',
            alignItems: 'center',
        }),
        menu: (provided, state) => ({
            ...provided,
            width: '200px', // Adjust the width as needed
        }),
    };



    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)

    }
    const StyledRating = styled(Rating)({
        '& .MuiRating-iconFilled': {
            color: '#442580',
        },

    });

    useEffect(() => {
        setPage(1);
    }, [rating, date, search, status])



    useEffect(() => {
        const params = { page: page, limit: limit }
        if (search != '' && search != null) {
            params.search = search
        }
        if (date) {
            params.start_date = moment(date[0]).format("MM-DD-YYYY")
            params.end_date = moment(date[1]).format("MM-DD-YYYY")
        }
        if (params.start_date == "Invalid date" || params.end_date == "Invalid date") {
            console.log(params, 'params');
            return
        }
        if (rating && rating != 0) {
            params.rating_range = rating
        }
        if (status && status != 0) {
            params.status = status
        }

        dispatch(
            feedbackList(params, (res) => { }),
        )
    }, [limit, page, search, date, rating, status])




    var newData = []
    //************Setting up paramters for table  */
    useEffect(() => {
        newData = feedback.list.map((item, index) => {
            return [
                "",
                item.feedback_from,
                item.feedback_to,
                item.comment,
                item.bus_number,
                item.firstName + " " + item.lastName,
                item.route,
                item.safety,
                item.reason,
                item.service_performance,
                item.driver_behaviour_conduct,
                item.vehicle_maintenance,
                item.rating,
                format(new Date(parseInt(item.created_at)), 'dd MMM yyyy,hh:mm a'),
                item.vehicle_id,

            ]
        })
        setTimeout(() => {
            setData(newData)
        }, 500)
    }, [feedback.list])





    useEffect(() => {

        var params = {};
        if (search != '' && search != null) {
            params.search = search
        }
        if (date) {
            params.start_date = moment(date[0]).format("MM-DD-YYYY")
            params.end_date = moment(date[1]).format("MM-DD-YYYY")
        }
        if (rating && rating != 0) {
            params.rating_range = rating
        }
        if (status && status != 0) {
            params.status = status
        }

        dispatch(
            feedbackListAll(params, (res) => {

                var allDataNew = res.map((item, index) => {
                    return [
                        "",
                        item.feedback_from,
                        item.feedback_to,
                        item.comment,
                        item.bus_number,
                        item.firstName + " " + item.lastName,
                        item.route,
                        item.safety,
                        item.reason,
                        item.service_performance,
                        item.driver_behaviour_conduct,
                        item.vehicle_maintenance,
                        item.rating,
                        format(new Date(parseInt(item.created_at)), 'dd MMM yyyy,hh:mm a'),


                    ]
                })
                setTimeout(() => {
                    setAllData(allDataNew);
                }, 500)
            }))

    }, [feedback.list])


    function downloadCSV2(args) {
        var data, filename, link
        var csv = ''
        var datasets = [
            {
                label: "Feedback",
                data: allData,

            },

        ]
        csv = convertChartDataToCSV({
            data: datasets[0],
            labels: ["", "From", "To", "Comment", "Bus No.", "User Name", "Route", "Safety", "Reason", "Service Performance", "Driver behaviour Conduct", "Vehicle Maintenance", "Rating", "Date Created", "Time Created"]
        })
        if (csv == null) return

        filename = 'feedback.csv'
        if (!csv.match(/^data:text\/csv/i)) {
            csv = 'data:text/csv;charset=utf-8,' + csv
        }

        // not sure if anything below this comment works
        data = encodeURI(csv)
        link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        document.body.appendChild(link) // Required for FF
        link.click()
        document.body.removeChild(link)

    }



    function convertChartDataToCSV(args) {
        let result, columnDelimiter, lineDelimiter, labels, data

        data = args.data.data || null
        if (data == null || !data.length) {
            return null
        }

        labels = args.labels || null
        if (labels == null || !labels.length) {
            return null
        }

        columnDelimiter = args.columnDelimiter || ','
        lineDelimiter = args.lineDelimiter || '\n'
        result = '' + columnDelimiter
        result += labels.join(columnDelimiter)
        result += lineDelimiter

        result += args.data.label.toString()

        for (let i = 0; i < data.length; i++) {
            result += lineDelimiter
            result += columnDelimiter
            result += data[i]
        }
        result += lineDelimiter

        return result
    }

    const itemsOpen = (e, index) => {
        history.push('/merchantItems')
    }
    //************Setting up paramters for table  */

    const columns = [
        {
            name: '',
            label: '',
            options: {
                filter: true,
                sort: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p style={{ width: '30px' }}>

                            {/* <i className=" ">
                                <img src={require('../../assets/images/Group 427318994.png')} />
                            </i> */}
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div style={{ width: '40px' }} >
                            {data[index][12] <= 1 &&
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#af1414" class="w-4 h-4">
                                    <path d="M2.75 2a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0v-2.624l.33-.083A6.044 6.044 0 0 1 8 11c1.29.645 2.77.807 4.17.457l1.48-.37a.462.462 0 0 0 .35-.448V3.56a.438.438 0 0 0-.544-.425l-1.287.322C10.77 3.808 9.291 3.646 8 3a6.045 6.045 0 0 0-4.17-.457l-.34.085A.75.75 0 0 0 2.75 2Z" />
                                </svg>
                            }
                            {data[index][12] >= 1.1 && data[index][12] <= 3.5 &&
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#f0db1f" class="w-4 h-4">
                                    <path d="M2.75 2a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0v-2.624l.33-.083A6.044 6.044 0 0 1 8 11c1.29.645 2.77.807 4.17.457l1.48-.37a.462.462 0 0 0 .35-.448V3.56a.438.438 0 0 0-.544-.425l-1.287.322C10.77 3.808 9.291 3.646 8 3a6.045 6.045 0 0 0-4.17-.457l-.34.085A.75.75 0 0 0 2.75 2Z" />
                                </svg>
                            }
                            {data[index][12] >= 3.6 && data[index][12] <= 5 &&
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#1dbb19" class="w-4 h-4">
                                    <path d="M2.75 2a.75.75 0 0 0-.75.75v10.5a.75.75 0 0 0 1.5 0v-2.624l.33-.083A6.044 6.044 0 0 1 8 11c1.29.645 2.77.807 4.17.457l1.48-.37a.462.462 0 0 0 .35-.448V3.56a.438.438 0 0 0-.544-.425l-1.287.322C10.77 3.808 9.291 3.646 8 3a6.045 6.045 0 0 0-4.17-.457l-.34.085A.75.75 0 0 0 2.75 2Z" />
                                </svg>
                            }

                            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#af1414" class="w-6 h-6">
                                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
                            </svg> */}

                        </div>
                    )

                },
            },
        },
        {
            name: 'from',
            label: 'from',
            options: {
                filter: true,
                sort: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>From</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'to',
            label: 'to',
            options: {
                filter: true,


                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>To</span>
                        </p>
                    )
                },
            },
        },




        {
            name: 'Comment',
            label: 'Comment',
            options: {
                filter: true,

                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Comment
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div style={{ width: '120px' }}>

                            <span style={{ wordWrap: "break-word" }}>{data[index][3].substring(0, 50)}  </span>
                            <span>{data[index][3].length > 50 ? "..." : ""}</span>
                        </div>
                    )
                },
            },
        },
        {
            name: 'Bus No.',
            label: 'Bus No.',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Bus No.</span>
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div>
                            <span>{data[index][4]}</span>
                        </div>
                    )
                },
            },
        },
        {
            name: 'user',
            label: 'user',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p >
                            <span>User</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'Route',

            label: 'Route',
            options: {
                display: false,
                download: true,
                filter: true,
                sort: false,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Route</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'safety',
            label: 'Safety',
            options: {
                filter: true,
                sort: false,
                display: false,
                download: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p >
                            <span>Safety</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'reason',
            label: 'Reason',
            options: {
                filter: true,
                sort: false,
                display: false,
                download: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p >
                            <span>Reason</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'service performance',
            label: 'Service Performancec',
            options: {
                filter: true,
                sort: false,
                display: false,
                download: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Service Performance</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'driver behaviour conduct',
            label: 'Driver Behaviour Conduct',
            options: {
                filter: true,
                sort: false,
                display: false,
                download: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p >
                            <span>Driver Behaviour Conduct</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'vehicle maintanence',
            label: 'Vehicle Maintanence',
            options: {
                filter: true,
                sort: false,
                display: false,
                download: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p >
                            <span>Vehicle Maintanence</span>
                        </p>
                    )
                },
            },
        },

        {
            name: 'Overall Rating',
            label: 'Overall Rating',
            options: {
                filter: true,
                sort: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Rating
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div className="actionField">
                            <StyledRating
                                name="size-large"
                                readOnly
                                value={data[index][12]}
                                getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
                                precision={0.5}

                            />


                        </div>
                    )
                },
            },
        },
        {
            name: 'Date Added',
            label: 'Date Added',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Date Added
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    const date = data[index][13]
                    return (
                        <div>
                            <span>{date} </span>
                        </div>
                    )
                },
            },
        },



    ]




    const setSearchValue = (data) => {
        setSearch(data)
        setPage(1)
    }

    const setNewPage = (page) => {
        setPage(page)

    }

    const options = {
        //  filterType: 'checkbox',
        title: 'Pie Chart',
        // downloadOptions:{filename: 'feedbacks.csv', separator: ','},
        // onDownload:function(columns , buildBody) => {

        // },
        selectableRowsHideCheckboxes: false,
        isRowSelectable: false,
        selectableRows: "none",
        download: false,
        fixedHeader: true,
        onDownload: (buildHead, buildBody, columns, data) => {

            let val = `${buildHead(columns)}${buildBody(data)}`.trim();
            return val;



        },
        filter: false,
        sort: true,
        sortOrder: {
            name: 'Date Added',
            direction: 'desc',  // Default sorting direction for the 'Date Added' column
          },
        print: false,
        viewColumns: false,
        pagination: false,
        // onRowClick: (rowData, rowMeta) => {
        //   dispatch(updateSelectedMerchantId(merchant.list[rowMeta.dataIndex].id));
        //   history.push("/merchantItems");
        // },

        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 30],
        caseSensitive: false,
        search: false,
        jumpToPage: true,
        tableBodyHeight: tableHeight,
        tableBodyMaxHeight: "none",
        count: feedback.total_users,
        onChangePage: (currentPage) => {
            setPage(currentPage + 1)
            return
        },
        onChangeRowsPerPage: (numberOfRows) => {
            setLimit(numberOfRows)
        },
        expandableRows: true,
        expandableRowsHeader: false,
        expandableRowsOnClick: true,
        // setRowProps: (row, dataIndex, rowIndex) => {

        //     if(data[dataIndex][11] < "2.5" ){
        //     return {

        //       style: { backgroundColor: '#ff00002b' },
        //     };
        //     }
        //     if(data[dataIndex][11] > "2.5" && data[dataIndex][11] < "3.5"){
        //         return {

        //             style: { backgroundColor: '#e8cb0c70' },
        //           };
        //     }

        //   },
        renderExpandableRow: (rowData, rowMeta) => {
            const colSpan = rowData.length + 1
            return (
                <TableRow>
                    <TableCell colSpan={colSpan}>
                        {' '}
                        <div class="container1 descriptoonBoxTable">
                            <div>
                                <p>
                                    From: <span class="promo">{data[rowMeta.dataIndex][1]}</span>
                                </p>
                                <p>
                                    To: <span class="promo">{data[rowMeta.dataIndex][2]}</span>
                                </p>
                                <p style={{ width: "100", wordWrap: "break-word" }}>
                                    Comment: <span class="promo">{data[rowMeta.dataIndex][3]}</span>
                                </p>

                                <p>
                                    Route: <span class="promo">{data[rowMeta.dataIndex][6]}</span>
                                </p>
                                <p>
                                    Safety: <span class="promo">{data[rowMeta.dataIndex][7]}</span>
                                </p>

                                <p>
                                    Date:{' '}
                                    <span class="promo">

                                        {data[rowMeta.dataIndex][13]}

                                    </span>
                                </p>

                            </div>
                            <div>
                                <p>
                                    User: <span class="promo">{data[rowMeta.dataIndex][5]}</span>
                                </p>
                                <p>
                                    Bus No.: <span class="promo">{data[rowMeta.dataIndex][4]}</span>
                                </p>
                                <p>
                                    Reason: <span class="promo">{data[rowMeta.dataIndex][8]}</span>
                                </p>
                                <p>
                                    Service Performance: <span class="promo">{data[rowMeta.dataIndex][9]}</span>
                                </p>
                                <p>
                                    Driver Behaviour Conduct: <span class="promo">{data[rowMeta.dataIndex][10]}</span>
                                </p>
                                <p>
                                    Vehicle Maintenance: <span class="promo">{data[rowMeta.dataIndex][11]}</span>
                                </p>

                            </div>
                        </div>
                    </TableCell>
                </TableRow>
            )
        },

        textLabels: {
            pagination: {
                next: 'Next Page',
                previous: 'Previous Page',
                displayRows: 'of',
            },
        },

        responsive: 'standard',
    }

    return (
        <div className="userPageWrapper">

            <div className="userPage merchantlist feedback ">
                <Loader loading={loaders.isFetching} />

                <div className="scroll-fix " >
                    <div className="titlediv">

                        {/* CODE UPDATE */}

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ marginTop: "10px" }} item xs={12} sm={12} md={5}>
                                <div style={{ display: 'flex', paddingBottom: "20px" }}>
                                    <div>
                                        <p className="headinguser">Feedback</p>
                                        <p className="subheadinggraph">
                                            Customer feedback
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div style={{ display: "flex", width: "550px" }}>

                                    <div style={{ width: "243px", height: "20px" }}
                                        item xs={12} sm={12} md={2}>
                                        <Select
                                            options={optionSelect}
                                            styles={customStyles}
                                            className="selectoptionRating"
                                            defaultValue={{ value: 0, label: "All" }}
                                            onChange={(e) => setStatus(e.value)}
                                            isSearchable={false} // Disable search box if you don't want it
                                            getOptionLabel={(option) => (
                                                <div>
                                                    <span>{option.icon}</span>
                                                    <span style={{ marginLeft: '8px' }}>{option.label}</span>
                                                    <span>{option.svg}</span>
                                                </div>
                                            )}
                                            getOptionValue={(option) => option.value}
                                        />


                                    </div>


                                    <div item xs={12} sm={12} md={2}>
                                        <div style={{ marginLeft: "10px", marginRight: "10px", marginBottom: "7px" }}
                                            className="search-wrapper">

                                            <TextField size='medium' label="Search" id="outlined-size-normal" defaultValue="" className='selectNew' onChange={(e) => setSearchValue(e.target.value)} />


                                        </div>
                                    </div>


                                    <div style={{ width: "200px" }} item xs={12} sm={12} md={1}>
                                        <button class="btnDownloadNew" style={{ height: "42px" }} onClick={() => downloadCSV2()}>
                                            <i class="fa fa-download"></i> Download
                                        </button>
                                    </div>

                                </div>
                                <div style={{ width: "373px" }} item xs={12} sm={12} md={4}>
                                    <div style={{ height: "5px", width: "100%", display: "block" }}>
                                        {/* <div>    */}
                                        <DateRangePicker showOneCalendar onClean={() => setDates(null)} size="lg" onChange={(e) => setDates(e)} disabledDate={combine(allowedMaxDays(90), afterToday())} placeholder="Date Range" />
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* CODE UPDATED */}



                    </div>
                </div>
            </div>
            <div className="userPage merchantlist userPageWithList">

                <div className="pagination-wrapper">
                    <div className="pagination">
                        <p>
                            Showing {feedback.list.length} out of {feedback.total_users} feedback{' '}
                        </p>
                    </div>

                    <Stack spacing={2}>
                        <Pagination
                            count={Math.ceil(feedback.total_users / limit)}
                            page={page}
                            onChange={(e, value) => setNewPage(value)}
                            color="primary"
                        />
                    </Stack>
                    <div className="pagination2">
                        <p>Rows Per Page</p>
                        <select className='pagination-select' onChange={(e) => updatePagination(e)}>
                                <option selected={limit == 10}>10</option>
                                <option selected={limit == 20}>20</option>
                                <option selected={limit == 30}>30</option>
                        </select>
                    </div>
                </div>


                <div ref={tableRef} style={{ overflowY: 'auto', height: tableHeight }}>
                    <MUIDataTable
                        className="custommuitablestyle"
                        columns={columns}
                        data={data}
                        responsive={responsive}
                        rowHover={true}
                        options={options}
                    />
                </div>
            </div>
        </div>
    )
}

export default Feedback
